import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import TestKeyboardInputDemo from './TestKeyboardInputDemo'
import TestKeyboardInputEditorActions from './TestKeyboardInputEditorActions'
import TestKeyboardInputElement from './TestKeyboardInputElement'
import TestKeyboardInputFormBrand from './TestKeyboardInputFormBrand'
import { STYLE_FORM_SCHEMA } from './TestKeyboardInputFormStyle'
import TestKeyboardInputFormValue from './TestKeyboardInputFormValue'
import keyboardInputIcon from './assets/testKeyboardInput.svg'

export default genElementConfig(CONFIG_ELEMENTS.testKeyboardInput, {
  label: t('elements.testKeyboardInput.label'),
  icon: keyboardInputIcon,
  group: ElementGroup.test,
  styleFields: STYLE_FORM_SCHEMA,
  Element: TestKeyboardInputElement,
  Demo: [TestKeyboardInputDemo],
  FormValue: TestKeyboardInputFormValue,
  FormBrand: TestKeyboardInputFormBrand,
  EditorActions: TestKeyboardInputEditorActions,
})
